import { ref, watch } from 'vue';

export function readJSON(key, fallback) {
  try {
    const saved = localStorage.getItem(key);
    if (saved !== null) return JSON.parse(saved);
  } catch (e) {
    console.warn(`Failed to load '${key}' from localStorage:`, e);
  }
  return fallback;
}

export function writeJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.warn(`Failed to save '${key}' to localStorage:`, e);
  }
}

// A ref that loads itself from localStorage on creation and saves itself
// on every change. `validate` may reject a stored value (e.g. it's no
// longer one of the allowed options), falling back to defaultValue.
export function usePersisted(key, defaultValue, { validate } = {}) {
  const loaded = readJSON(key, defaultValue);
  const state = ref(validate && !validate(loaded) ? defaultValue : loaded);

  watch(state, (value) => writeJSON(key, value), { deep: true });

  return state;
}
